const BrowserUniqueTabID = () => {
    if (!window.name) {
        window.name = `tab-${Math.random().toString(36).substr(2, 9)}`;
    };
    return window.name;
};

export default BrowserUniqueTabID;